"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Check, Minus } from "lucide-react";
import { Checkbox as AriaCheckbox, CheckboxGroup as AriaCheckboxGroup, CheckboxGroupProps as AriaCheckboxGroupProps, ValidationResult as AriaValidationResult, composeRenderProps, Text, type CheckboxProps as AriaCheckboxProps } from "react-aria-components";
import { cn } from "@/utils/cn";
import { FieldError, Label, labelVariants } from "./field";
const CheckboxGroup = AriaCheckboxGroup;
const Checkbox = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = composeRenderProps(className, _temp);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = composeRenderProps(children, _temp2);
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <AriaCheckbox className={t1} {...props}>{t2}</AriaCheckbox>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
interface JollyCheckboxGroupProps extends AriaCheckboxGroupProps {
  label?: string;
  description?: string;
  errorMessage?: string | ((validation: AriaValidationResult) => string);
}
function JollyCheckboxGroup(t0) {
  const $ = _c(20);
  let children;
  let className;
  let description;
  let errorMessage;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      label,
      description,
      errorMessage,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = description;
    $[4] = errorMessage;
    $[5] = label;
    $[6] = props;
  } else {
    children = $[1];
    className = $[2];
    description = $[3];
    errorMessage = $[4];
    label = $[5];
    props = $[6];
  }
  let t1;
  if ($[7] !== className) {
    t1 = composeRenderProps(className, _temp3);
    $[7] = className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== description || $[10] !== errorMessage || $[11] !== label) {
    t2 = children_0 => <><Label>{label}</Label>{children_0}{description && <Text className="text-sm text-muted-foreground" slot="description">{description}</Text>}<FieldError>{errorMessage}</FieldError></>;
    $[9] = description;
    $[10] = errorMessage;
    $[11] = label;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== children || $[14] !== t2) {
    t3 = composeRenderProps(children, t2);
    $[13] = children;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== props || $[17] !== t1 || $[18] !== t3) {
    t4 = <CheckboxGroup className={t1} {...props}>{t3}</CheckboxGroup>;
    $[16] = props;
    $[17] = t1;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
function _temp3(className_0) {
  return cn("group flex flex-col gap-2", className_0);
}
export { Checkbox, JollyCheckboxGroup };
function _temp(className_0) {
  return cn("group/checkbox flex items-center gap-x-2", "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-70", labelVariants, className_0);
}
function _temp2(children_0, renderProps) {
  return <><div className={cn("flex size-4 shrink-0 items-center justify-center rounded-sm border border-primary text-current ring-offset-background", "group-data-[focus-visible]/checkbox:outline-none group-data-[focus-visible]/checkbox:ring-2 group-data-[focus-visible]/checkbox:ring-ring group-data-[focus-visible]/checkbox:ring-offset-2", "group-data-[indeterminate]/checkbox:bg-primary group-data-[selected]/checkbox:bg-primary group-data-[indeterminate]/checkbox:text-primary-foreground  group-data-[selected]/checkbox:text-primary-foreground", "group-data-[disabled]/checkbox:cursor-not-allowed group-data-[disabled]/checkbox:opacity-50", "group-data-[invalid]/checkbox:border-destructive group-data-[invalid]/checkbox:group-data-[selected]/checkbox:bg-destructive group-data-[invalid]/checkbox:group-data-[selected]/checkbox:text-destructive-foreground", "focus:outline-none focus-visible:outline-none")}>{renderProps.isIndeterminate ? <Minus className="size-4" /> : renderProps.isSelected ? <Check className="size-4" /> : null}</div>{children_0}</>;
}